(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('cityService', cityService);

    cityService.$inject = ['$http', 'CONFIG', 'messageService'];

    function cityService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/cities';
        var service = {
            getCities: getCities,
            getPageCities: getPageCities,
            getCity: getCity,
            saveCity: saveCity,
            updateCity: updateCity,
            deleteCity: deleteCity,
            getCitiesByRegion: getCitiesByRegion,
            thereCityNameByRegion: thereCityNameByRegion
        }

        return service;

        function getCities(){
            return $http.get(urlBase + '?detailed=true')
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.cities : [];
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getPageCities(page, size){
            return $http.get(urlBase + "/" + 'page?page=' + page + '&size=' + size + '&detailed=true')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getCity(cityId){
            return $http.get(urlBase + "/" + cityId + '?detailed=true')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function saveCity(city){
            return $http.post(urlBase, city)
                .then(function(response){
                    messageService.register('cities')
                    return response;
                })
                .catch(function(){
                    messageService.registerError('cities')
                });
        }

        function updateCity(cityIdRegionId, city){
            return $http.put(urlBase + "/" + cityIdRegionId, city)
                .then(function(response){
                    messageService.registerUpdate('cities')
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('cities')
                });
        }

        function deleteCity(cityIdRegionId){
            return $http.delete(urlBase + "/" + cityIdRegionId)
                .then(function(response){
                    messageService.registerDelete('cities')
                    return response;
                })
                .catch(function(error){
                    if(error.data.message.indexOf('asociación')> -1 || error.data.message.indexOf('asociacion') > -1
                        || error.data.message.indexOf('association') > -1 || error.data.message.indexOf('associated') > -1){
                        messageService.registerDeleteGeneralError('cities','air.city.associatedAirports')
                    }else{
                        messageService.registerDeleteError('cities')
                    }
                });
        }

        function getCitiesByRegion(regionId, active, detailed){
            return $http.get(urlBase + "/" + regionId + "/regions?active=" + active + "&detailed=" + detailed)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.cities : [];
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function thereCityNameByRegion(name, id){

            return $http.get(urlBase + "/" + id + "/thereCityName/" + name, {headers: {'Loading-Overlay': false}})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('')
                });
        }
    };

})();
